export default [
  // {
  //   path: "/csksxwsxhv2",
  //   name: "csksxwsxhv2",
  //   meta: {
  //     title: "视宣号精英版"
  //   },
  //   component: () => import("@/views/xwsxh/xwsxhv2")
  // },
  {
    path: "/xnhxwsxhv2",
    name: "xnhxwsxhv2",
    meta: {
      title: "视宣号精英版"
    },
    component: () => import("@/views/xwsxh/xwsxhv2")
  },
  {
    path: "/xnhxwsxhv3",
    name: "xnhxwsxhv3",
    meta: {
      title: "视宣号精英版"
    },
    component: () => import("@/views/xwsxh/xwsxhv3Baobei")
  },
  {
    path: "/xnhxwsxhv3Thirty",
    name: "xnhxwsxhv3Thirty",
    meta: {
      title: "视宣号标准版"
    },
    component: () => import("@/views/xwsxh/xwsxhv4Baobei")
  },
  {
    path: "/xnhxwsxhv3Quanzipublic",
    name: "xnhxwsxhv3Quanzipublic",
    meta: {
      title: "圈子彩铃公众版"
    },
    component: () => import("@/views/xwsxh/xwsxhv5Baobei")
  },
  {
    path: "/xwsxhvCompany",
    name: "xwsxhvCompany",
    meta: {
      title: "企业视频彩铃"
    },
    component: () => import("@/views/xwsxh/xwsxhvCompany")
  },
  {
    path: "/xwsxhvUser",
    name: "xwsxhvUser",
    meta: {
      title: "企业视频彩铃"
    },
    component: () => import("@/views/xwsxh/xwsxhvUser")
  },
  {
    path: "/xwsxhCompanyComplex",
    name: "xwsxhCompanyComplex",
    meta: {
      title: "企业视频彩铃"
    },
    component: () => import("@/views/xwsxh/xwsxhCompanyComplex")
  },
  {
    path: "/xwsxhComplexApplet",
    name: "xwsxhComplexApplet",
    meta: {
      title: "企业视频彩铃"
    },
    component: () => import("@/views/xwsxh/xwsxhComplexApplet")
  },
  {
    path: "/xwsxhOldApplet",
    name: "xwsxhOldApplet",
    meta: {
      title: "企业视频彩铃"
    },
    component: () => import("@/views/xwsxh/xwsxhOldApplet")
  },
  {
    path: "/xwsxhOldManApplet",
    name: "xwsxhOldManApplet",
    meta: {
      title: "企业视频彩铃"
    },
    component: () => import("@/views/xwsxh/xwsxhOldManApplet")
  },
  {
    path: "/xwsxhYouthApplet",
    name: "xwsxhYouthApplet",
    meta: {
      title: "企业视频彩铃"
    },
    component: () => import("@/views/xwsxh/xwsxhYouthApplet")
  },
  {
    path: "/xwsxhComplex",
    name: "xwsxhComplex",
    meta: {
      title: "企业视频彩铃"
    },
    component: () => import("@/views/xwsxh/xwsxhCompanyComplexBeiFen20250427")
  },
  {
    path: "/xwsxhXnhComplex",
    name: "xwsxhXnhComplex",
    meta: {
      title: "企业视频彩铃"
    },
    component: () => import("@/views/xwsxh/xwsxhXnhComplex")
  },
  {
    path: "/xwsxhComplexMorering",
    name: "xwsxhComplexMorering",
    meta: {
      title: "企业视频彩铃"
    },
    component: () => import("@/views/xwsxh/xwsxhComplexMorering")
  },
  {
    path: "/xwsxhComplexMorecase",
    name: "xwsxhComplexMorecase",
    meta: {
      title: "企业视频彩铃"
    },
    component: () => import("@/views/xwsxh/xwsxhComplexMorecase")
  },
  {
    path: "/xwsxhwxAd",
    name: "xwsxhwxAd",
    meta: {
      title: "企业视频彩铃"
    },
    component: () => import("@/views/xwsxh/sxhWxAd")
  }
];



// WEBPACK FOOTER //
// ./src/router/modules/xwsxh.js